<ion-header>
  <ion-toolbar>
    <ion-title>{{ "crowd_login" | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()"
        ><ion-icon slot="icon-only" name="close-outline"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="form-container">
    <app-login-form
      [hideHeader]="true"
      (loginSuccessEvent)="dismiss()"
      (signupClickedEvent)="dismiss()"
      (forgotPasswordClickedEvent)="dismiss()"
    />
  </div>
</ion-content>
